module.exports = __webpack_public_path__ + "static/media/Style10.09fb342d.PNG";